import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate } from "@angular/router";
import { Store } from "@ngrx/store";
import { Jurisdiction } from "@obg/core.config";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { JurisdictionSelector } from "../jurisdiction/jurisdiction.selector";
import { CoreState } from "../state";

@Injectable({
	providedIn: "root",
})
export class AamsComplianceGuard implements CanActivate {
	constructor(private store: Store<CoreState>) {}

	canActivate(_route: ActivatedRouteSnapshot): Observable<boolean> {
		return this.store
			.select(JurisdictionSelector.get)
			.pipe(map((jurisdiction) => jurisdiction === Jurisdiction.Aams));
	}
}
